var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{attrs:{"background":"","current-page":_vm.currentPage,"page-size":_vm.pageSize,"layout":"total, prev, pager, next, jumper","total":_vm.total},on:{"current-change":_vm.paginationChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }